(function ($, Drupal) {

  /**
   * Creates a bootstrap modal dialog at the end of the body to avoid z-index
   * and positional issues.
   *
   * Content is then placed into the dialog when it is toggled.
   *
   * Example:
   *
   * <div class="global-modal-wrapper">
   *
   *   // the element with data-toggle=global-modal is what activates the modal
   * when clicked
   *   <button type="button" class="btn btn-info btn-lg"
   * data-toggle="global-modal">Open Modal 2</button>
   *
   *   // the element with .content is the content of the modal
   *   <div class="content">
   *     <div class="modal-content">
   *       <div class="modal-header no-bottom-border">
   *         <button type="button" class="close"
   * data-dismiss="modal">&times;</button>
   *       </div>
   *       <div class="modal-body">
   *         <div>icons</div>
   *       </div>
   *     </div>
   *   </div>
   *
   *  </div>
   *
   **/

  var MODAL_ID='global-bootstrap-model';

  function $getModal() {
    return $('#' + MODAL_ID);
  }

  /**
   * @todo this should probably be handled better, but this is a quick solution to get this working.
   *
   * Re-initializes things that need to be re-initializated when the model is created, this is a global re-initialize
   * on something that should really be a case-by-case basis, but don't really have time to create a better solution
   * right now.
   *
   * See function body for more details.
   */
  function runTriggers() {
    // The modal is used on mobile on the /blog/[title] page and displays the add-to-any social media links.
    // Unfortunately, that are initalized via a behavior, so the links loaded via the modal will not trigger
    // properly. Therefore when the modal is display the add-to-any initial call needs to be re-invoked such
    // that the links work propertly.
    if (window.a2a) {
      a2a.init_all(); // Init all uninitiated AddToAny instances
    }
  }

  function findGlobalDialogs() {
    if (!$getModal().length) {
      $('body').append(
      '<div class="modal fade" id="' + MODAL_ID + '" role="dialog" data-backdrop="false">' +
        '<div class="modal-dialog"></div>' +
      '</div>'
      );
    }
    $('.global-modal-wrapper > [data-toggle=global-modal]').click(function () {
      var $elem = $(this);
      $elem.fadeOut(50);
      setTimeout(function () {
        $elem.show()
      }, 1000);
      var content = $elem.parent().find('> .content');
      var $modal = $getModal();
      $modal.find('.modal-dialog').html(content.html());
      $modal.modal('show');
      runTriggers();
    });
  };

  Drupal.behaviors.globalBootstrapModal = {
    attach: function (context, settings) {
      findGlobalDialogs();
    }
  }

})(jQuery, Drupal);
